/**
 * Do not edit directly, this file was auto-generated.
 */

export const COPY_L_LIGHT = {
  fontWeight: 300,
  fontSize: '18px',
  lineHeight: '26px'
}

export const COPY_L_SEMIBOLD = {
  fontWeight: 600,
  fontSize: '18px',
  lineHeight: '26px'
}

export const COPY_M_LIGHT = {
  fontWeight: 300,
  fontSize: '16px',
  lineHeight: '24px'
}

export const COPY_M_SEMIBOLD = {
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '24px'
}

export const COPY_S_REGULAR = {
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '22px'
}

export const COPY_S_SEMIBOLD = {
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '22px'
}

export const COPY_XS_REGULAR = {
  fontWeight: 400,
  fontSize: '11px',
  lineHeight: '16px'
}

export const COPY_XS_SEMIBOLD = {
  fontWeight: 600,
  fontSize: '11px',
  lineHeight: '16px'
}

export const HEADING_3XL = {
  fontWeight: 900,
  fontSize: '76px',
  lineHeight: '76px'
}

export const HEADING_XXL = {
  fontWeight: 900,
  fontSize: '65px',
  lineHeight: '65px'
}

export const HEADING_XL = {
  fontWeight: 900,
  fontSize: '44px',
  lineHeight: '44px'
}

export const HEADING_L = {
  fontWeight: 900,
  fontSize: '30px',
  lineHeight: '30px'
}

export const HEADING_M = {
  fontWeight: 500,
  fontSize: '26px',
  lineHeight: '34px'
}

export const HEADING_S = {
  fontWeight: 500,
  fontSize: '23px',
  lineHeight: '30px'
}

export const HEADING_XS = {
  fontWeight: 600,
  fontSize: '19px',
  lineHeight: '26px'
}

export const HEADING_XXS = {
  fontWeight: 500,
  fontSize: '18px',
  lineHeight: '24px'
}

export const HEADING_3XS = {
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '22px'
}

export const HEADING_4XS = {
  fontWeight: 700,
  fontSize: '15px',
  lineHeight: '18px'
}

export const HEADING_5XS = {
  fontWeight: 500,
  fontSize: '13px',
  lineHeight: '16px'
}

export const HEADING_6XS = {
  fontWeight: 500,
  fontSize: '10px',
  lineHeight: '12px'
}